// extracted by mini-css-extract-plugin
export var image = "dr_dp";